import { Ticket } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useMyTicketCounts } from "@/hooks/use-tickets";

/**
 * The top bar's way to the Tickets screen, with how many of my tickets need
 * me — on every page, like the WhatsApp badge. The app shell renders it only
 * with `tickets.view`.
 */
export function TicketTopbarButton() {
  const counts = useMyTicketCounts(true);
  const todo = counts.data?.todo ?? 0;
  const late = counts.data?.late ?? 0;
  const label =
    todo > 0
      ? `Tickets — ${todo} to do${late > 0 ? `, ${late} late` : ""}`
      : "Tickets — nothing to do";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon-sm" asChild className="relative">
          <Link to="/tickets" aria-label={label}>
            <Ticket aria-hidden="true" />
            {todo > 0 ? (
              <span
                aria-hidden="true"
                className={
                  late > 0
                    ? "absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1 text-xs font-semibold tabular-nums leading-none text-destructive-foreground"
                    : "absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-xs font-semibold tabular-nums leading-none text-primary-foreground"
                }
              >
                {todo > 99 ? "99+" : todo}
              </span>
            ) : null}
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
